import { makeAutoObservable } from 'mobx'
import { mx } from 'store/base/mx'
import { InferenceData } from 'type/inference'

export class PreviewStore {
  readonly inferences: InferenceData[]
  private _index: number = 0

  constructor(inferences: InferenceData[]) {
    makeAutoObservable(this)
    this.inferences = inferences
  }

  get index(): number {
    return this._index
  }

  set index(index: number) {
    const max = this.inferences.length - 1
    this._index = Math.max(0, Math.min(max, index))
  }

  get inference(): InferenceData | undefined {
    return this.inferences[this.index]
  }
}

export const preview = mx.ref<PreviewStore>()
